import { Dispatch, SetStateAction } from 'react';

import { CloseOutlined } from '@ant-design/icons';
import { Button } from 'antd';

import styles from './styles.module.css';

type Props = {
  setShowBanner: Dispatch<SetStateAction<boolean>>;
};

const Banner = ({ setShowBanner }: Props) => {
  return (
    <div className={styles.container}>
      <p className={styles.text}>Conheça a Blinket!</p>
      <a href={'https://www.eduzz.com/produtos/blinket'}>
        <Button className={styles.buttonText}>Conheça a Blinket</Button>
      </a>
      <CloseOutlined onClick={() => setShowBanner(false)} />
    </div>
  );
};

export default Banner;
